import { Customer } from "../../../models";

export const getCustomer = (data: any): Customer => ({
  id: data.id,
  firstName: data.attributes.first_name,
  lastName: data.attributes.last_name,
  email: data.attributes.email,
  phoneNumber: data.attributes.phone_number,
  isFavorite: !!data.attributes.is_favorite,
  openOrdersCount: data.attributes.open_orders_count ?? 0,
  pastOrdersCount: data.attributes.past_orders_count ?? 0,
});

export const getCustomers = (data: any): Customer[] => data.map(getCustomer);
